import { Grid } from "@mui/material";
import React from "react";

export function AcxGradientBorderContainer(props: {
    children: React.ReactNode;
    backgroundColor?: string;
}) {
    return (
        <Grid
            className={"no-export"}
            container
            direction={"column"}
            alignItems="start"
            wrap={"nowrap"}
            gap={2}
            sx={(theme) => ({
                padding: theme.spacing(1),
                background: `
                    linear-gradient(${props.backgroundColor || "#F3F4F6"}, ${
                    props.backgroundColor || "#F3F4F6"
                }) padding-box, 
                    linear-gradient(131deg, #32D1B7 3.43%, #349AC7 70.89%, #3664D6 100.5%) border-box
                `,
                border: "2px solid transparent",
                borderRadius: theme.spacing(0.5), // radius applies to both layers
            })}
        >
            {props.children}
        </Grid>
    );
}
